<script>
import _ from 'lodash'
import Prism from 'prismjs'

export default {
  computed: {
    copy_icon() {
      return this.copied ?
        `fa-clipboard-check` : `far fa-clipboard`
    },
    current_plain_text_snippet() {
      if(!this.content.length) return ''
      return this.content[this.tab].content
    }
  },
  data() {
    return {
      copied: false,
      tab: 0
    }
  },
  methods: {
    format_snippet: _.memoize(snippet => {
      const format =
        Prism.languages[snippet.lang] || Prism.languages.shellsession
      return Prism.highlight(snippet.content, format)
    }),
    on_copy_click() {
      const input = document.createElement('textarea')
      document.body.appendChild(input)
      input.value = this.current_plain_text_snippet
      input.setSelectionRange(0, 99999)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.copied = true
    }
  },
  mounted() {
    Prism.highlightAll()
  },
  name: 'doc-code',
  props: {
    content: {type: Array, default: () => []}
  },
  watch: {
    tab(curr, prev) {
      if(curr !== prev) {
        this.copied = false
      }
    }
  }
}
</script>

<template>
<div class='doc-code d-flex flex-column my-2'>
  <div class='d-flex align-center'>
    <v-tabs v-model='tab' color='secondary'>
      <v-tab v-for='(snippet, i) in content' :key='i'
        v-text='snippet.label || snippet.lang'/>
    </v-tabs>
    <v-btn @click='on_copy_click' class='mx-2' color='primary' icon>
      <v-icon small>{{copy_icon}}</v-icon>
    </v-btn>
  </div>
  <div class='d-flex flex-grow-1 code-snippet-container pa-2'>
    <code v-html='format_snippet(content[tab])' class='code-snippet px-4'/>
  </div>
</div>
</template>

<style lang='sass' scoped>
.doc-code
  .code-snippet-container
    overflow: auto

    .code-snippet
      background-color: transparent
      color: #ccc
      font-size: 1.1em
      white-space: pre

      code
        box-shadow: none !important

.theme--dark
  .doc-code
    .code-snippet-container
      background-color: var(--v-grey-darken8)
      border-top: 1px solid var(--v-grey-darken10)

.theme--light
  .doc-code
    background-color: white
    .code-snippet-container
      background-color: white
      border-top: 1px solid var(--v-grey-lighten4)
      code
        color: var(--v-grey-darken8) !important
</style>
